import React from "react";
import { Route, Routes } from "react-router-dom";
import AppFooter from "../components/AppFooter";
import { AuthInfo } from "../context/AuthContext";
import { GeneralInfo } from "../context/GeneralInfoContext";
import { PrivateInfo } from "../context/PrivateInfoContext";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import PageNotFound from "../pages/PageNotFound";
import AuthRoute from "./AuthRoute";

function RoutesIndex(){
return(<>
        <Routes>
            <Route path="/" element={
            <GeneralInfo>
                <Login />
            </GeneralInfo>
            } />
            <Route path="/dashboard" element={
            <AuthRoute redirectTo="/">
                <GeneralInfo>
                    <AuthInfo>
                        <PrivateInfo>
                            <Dashboard />
                        </PrivateInfo>
                    </AuthInfo>
                </GeneralInfo>
            </AuthRoute>
            } />  
            <Route path="*" element={<PageNotFound />} />    
        </Routes>
        <AppFooter />
</>
)
}

export default RoutesIndex